<template>
    <ai-tree-list-edit
        ref="refData"
        :meta="metaData"
        :to-remove-toolbar-items-names="removeToolbarBtns"
        @toolbar-button-click="onToolbarClick"
        @delete-click="onDeleteClick"
        @cell-click='onNsiClick'
        class="qs-sxpr-swp-view"
    />
</template>
<script>
export default {
    name: 'qs-sxpr-swp-view',
};
</script>
<script setup>

import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    fromCard: {
        type: Boolean,
        default: () => false,
    },
});

const refData = ref(null);
const isNsiChoice = ref(false);
const selectedNsiKod = ref(null);

const emits = defineEmits(['choose-nsi']);

onMounted(async () => {
    await onStart(); // refData.value?.setDataSource();
});

const removeToolbarBtns = computed(() => {
    if (props.fromCard) {
        return removeToolbarBtnsList.filter(item => item !== 'choice');
    }
    return removeToolbarBtnsList;
});

const onStart = async (keySelect) => {
    await refData.value?.setDataSource();
    let keySelectFocus = keySelect ? keySelect : null;
    if(!keySelectFocus) {
        const dataTree = await refData.value?.getTreeListDataSource();
        keySelectFocus = dataTree?.length ? dataTree[0].kod_sxp_swp : null;
        keySelectFocus = 1;
        selectedNsiKod.value = keySelectFocus;
    }
    await refData.value?.treeListInstance.option('focusedRowKey', keySelectFocus);
};

const onToolbarClick = async (event) => {
    const componentName = event?.item?.component?.name;
    if (componentName === 'choice') {
        isNsiChoice.value = true;
        await beforeNsiClose();
    }
};

const beforeNsiClose = async () => {
    const canClose = await refData.value?.checkBeforeClose();
    if (!canClose) return false;
    const dataTree = await refData.value?.getTreeListDataSource();
    const nsiChoiceItem = await dataTree.find(item => {
        return item.kod_sxp_swp === selectedNsiKod.value;
    });
    emits('choose-nsi', nsiChoiceItem, isNsiChoice.value);
};

const onNsiClick = async (event) => {
    selectedNsiKod.value = event.key;
};

defineExpose({
    beforeNsiClose: beforeNsiClose,
    onStart: (keySelect = null) => onStart(keySelect),
});


const metaData = {
    'keyExpr': 'kod_sxp_swp',
    'selectionMode': 'single',
    'selectButtonMode': 'single',
    'columns': [
        {
            'name': 'kod_sxp_swp',
            'caption': 'kod_sxp_swp',
            'dataField': 'kod_sxp_swp',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'name',
            'caption': 'Наименование',
            'dataField': 'name',
            'allowEditing': true,
            'width': '50%',
            'index': 2,
            'visible': true,
        },
        {
            'name': 'kod_r',
            'caption': 'kod_r',
            'dataField': 'kod_r',
            'allowEditing': false,
            'width': 250,
            'index': 3,
            'visible': false,
        },
        {
            'name': 'kpd',
            'caption': 'КПД теплообменников',
            'dataField': 'kpd',
            'dataType': 'number',
            'alignment': 'left',
            'allowEditing': true,
            'width': '50%',
            'index': 4,
            'visible': true,
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "allowEditing": false,
            'width': 30,
            'minWidth': 30,
            "index": 5,
            "visible": true
        }
    ],
    'api': {
        'select': 'tep_nsi./tep-nsi/qs-sxpr-swp-select/get',
        'save': 'tep_nsi./tep-nsi/qs-sxpr-swp-save/set',
    },
    'viewId': 'qs-sxpr-swp',
    'parentIdExpr': 'kod_r',
    'findTool': 'filter',
};


const removeToolbarBtnsList = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];

</script>
